var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeachers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1122 52.0003V47.5559C43.1122 45.1984 42.1757 42.9375 40.5087 41.2705C38.8417 39.6035 36.5808 38.667 34.2233 38.667H16.4455C14.088 38.667 11.8271 39.6035 10.1601 41.2705C8.49315 42.9375 7.55664 45.1984 7.55664 47.5559V52.0003",
    stroke: "#149A53",
    strokeWidth: 4.44444,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3323 29.7778C30.2415 29.7778 34.2211 25.7981 34.2211 20.8889C34.2211 15.9797 30.2415 12 25.3323 12C20.4231 12 16.4434 15.9797 16.4434 20.8889C16.4434 25.7981 20.4231 29.7778 25.3323 29.7778Z",
    stroke: "#149A53",
    strokeWidth: 4.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4421 52.0005V47.5561C56.4406 45.5866 55.7851 43.6733 54.5784 42.1168C53.3718 40.5602 51.6823 39.4484 49.7754 38.9561",
    stroke: "#149A53",
    strokeWidth: 4.44444,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8906 12.2891C42.8027 12.7786 44.4974 13.8906 45.7076 15.4498C46.9178 17.0089 47.5747 18.9265 47.5747 20.9002C47.5747 22.8739 46.9178 24.7915 45.7076 26.3506C44.4974 27.9097 42.8027 29.0217 40.8906 29.5113",
    stroke: "#149A53",
    strokeWidth: 4.44444,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachers);
export default __webpack_public_path__ + "static/media/teachers.788d5865c782bbe059cfa65d4133cee6.svg";
export { ForwardRef as ReactComponent };